import { render, staticRenderFns } from "./Prefix.vue?vue&type=template&id=bd0327a2"
import script from "./Prefix.vue?vue&type=script&lang=js"
export * from "./Prefix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports